module.exports = __webpack_public_path__ + "img/3.26db7733.jpg";